import { AbstractControl } from '@angular/forms';
import { of, OperatorFunction, pipe } from 'rxjs';
import {
  distinctUntilChanged,
  map,
  skip,
  startWith,
  switchMap,
} from 'rxjs/operators';

export function controlValid(): OperatorFunction<
  AbstractControl | null | undefined,
  boolean
> {
  return pipe(
    switchMap(
      (control: AbstractControl | null | undefined) =>
        control?.statusChanges.pipe(
          map(() => control.valid),
          startWith(control.valid)
        ) ?? of(false)
    ),
    distinctUntilChanged()
  );
}

export function controlValidityChanges(): OperatorFunction<
  AbstractControl | null | undefined,
  boolean
> {
  return pipe(controlValid(), skip(1));
}
